var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header__menu"},[_c('app-menu')],1),_c('div',{staticClass:"header__user"},[(_vm.isAuthInitialized)?_c('user-bar',{on:{"logout":_vm.logout}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }